import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { ContactComponent } from "./views/contact/contact.view.component";
import { HomeComponent } from "./views/home/home.view.component";
import { InProgressComponent } from "./views/inprogress/inprogress.view.component";
import { NomadComponent } from "./views/nomad/nomad.view.component";
import { NotFoundComponent } from "./views/notfound/notfound.view.component";

const routes: Routes = [
  { path: "", component: InProgressComponent },
  { path: "contact", component: ContactComponent },
  { path: "ahoy", component: HomeComponent },
  { path: "nomad", component: NomadComponent },
  { path: "404", component: NotFoundComponent },
  { path: "**", redirectTo: "/404" },
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forRoot(routes)],
})
export class RoutingModule { }



// WEBPACK FOOTER //
// ./src/app/routing.module.ts